"use client";

import styled from "styled-components";

//Components
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import Image from "../image";

export const Modal = styled(Dialog)``;

export const BoxImageVideo = styled.div`
  position: relative;
  padding-bottom: 50%;
  z-index: 0;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #000;
    z-index: 3;
    opacity: 0.5;
    border-radius: 15px 15px 0 0;
    transition: all 0.3s;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    margin-left: -20px;
    z-index: 4;
    width: 40px;
    height: 40px;
    stroke: #fff;
  }
`;

export const TumbVideo = styled(Image)`
  width: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  border-radius: 15px 15px 0 0;
  z-index: 1;
`;

export const TitleVideo = styled.h4`
  padding: 10px 15px;
  font-family: "Helvetica Neue Medium";
  font-size: 14px;
  text-align: left;
  color: var(--textLight);
`;

export const ButtonModal = styled(DialogTrigger)`
  cursor: pointer;
  background: var(--backgroundColorCard);
  border-radius: 15px;
  transition: 0.3s;
  box-shadow: 0 8px 20px var(--shadowColor);

  &:hover {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
    // transform: translateY(-5px);

    ${BoxImageVideo} {
      &:before {
        opacity: 0.3;
      }
    }
  }
`;

export const IframeComponent = styled.iframe`
  width: 100%;
  border-radius: 15px;
`;

export const TitleModalVideo = styled(DialogTitle)`
  font-family: "Roboto Light";
  font-size: 20px;
  color: #fff;
  margin-bottom: 20px;
`;

export const ModalHeader = styled(DialogHeader)``;

export const ModalContent = styled(DialogContent)`
  background: transparent;
  border: none;
  padding: 0;
  box-shadow: none;
  z-index: 999;

  button {
    margin-top: -36px;
    cursor: pointer;
    margin-right: -12px;
    color: #fff;

    &:focus {
      border: none;
      outline: none;
      box-shadow: none;
    }
  }
`;
